<template>
        <v-card>
          <v-toolbar dense color="red accent-2" dark>
            <v-toolbar-title>Escalas</v-toolbar-title>
          </v-toolbar>
          <v-data-table :headers="headers" :items="getScalesFinisheds" multi-sort :search="search">
            <template v-slot:top>
              <v-text-field v-model="search" label="Pesquisar" class="mx-4"></v-text-field>
            </template>
            <template v-slot:[`item.department`]="{ item }">
              <td>
                {{ GET_departmentById(item.department_id).department }}
              </td>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn :key="item.id" icon link large text @click="downloadPdf(item.id)">
                <v-icon large color="blue">mdi-cloud-download</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'ScaleList',
  components: {
    // ScaleFormCreate
  },
  data: function () {
    return {
      search: '',
      headers: [
        { text: 'Mês', sortable: false, value: 'month_name' },
        { text: 'Ano', value: 'year' },
        { text: 'Setor', value: 'department' },
        { text: 'Status', value: 'status_name' },
        { text: 'Ações', value: 'actions' },
      ],
    }
  },
  computed: {
    ...mapGetters('utils', ['GET_departmentById']),
    ...mapGetters('coordinator', ['getScalesFinisheds']),
    ...mapState('coordinator', ['scales']),
    ...mapState('utils', ['departments']),
  },
  methods: {
    ...mapActions('coordinator', ['ActionDownloadScalePDF']),
    async downloadPdf(scale_id) {
      await this.ActionDownloadScalePDF(scale_id)
    },
  },
}
</script>
